export default "/images/vendor/flag-icon-css/flags/1x1/ke.svg?9ea890912ffd2f80e7a3182a0c325afc";